var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2803 7.28033C14.5732 6.98744 14.5732 6.51256 14.2803 6.21967C13.9874 5.92678 13.5126 5.92678 13.2197 6.21967L8.21967 11.2197C7.92678 11.5126 7.92678 11.9874 8.21967 12.2803L13.2197 17.2803C13.5126 17.5732 13.9874 17.5732 14.2803 17.2803C14.5732 16.9874 14.5732 16.5126 14.2803 16.2197L9.81066 11.75L14.2803 7.28033Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPageIcon);
export default __webpack_public_path__ + "static/media/PreviousPageIcon.e895092ff09e1478e7bdd20f897f6fcf.svg";
export { ForwardRef as ReactComponent };